export const types = {
    START_FETCHING:    'START_FETCHING',
    STOP_FETCHING:     'STOP_FETCHING',
    EMIT_ERROR:        'EMIT_ERROR',
    SET_ONLINE_STATE:  'SET_ONLINE_STATE',
    SET_OFFLINE_STATE: 'SET_OFFLINE_STATE',
};
